import { Box, IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PropTypes from "prop-types";
import { analyticsPeriods } from "./analyticsPeriod";

export default function AnalyticsPeriodFilter({ value, onChange, label }) {
  const selectedIndex = Math.max(0, analyticsPeriods.findIndex((period) => period.value === value));

  return (
    <Box
      role="group"
      aria-label={`${label} period`}
      sx={{ display: "inline-flex", alignItems: "center", flexShrink: 0, gap: 0.25 }}
    >
      <IconButton
        size="small"
        aria-label={`${label}: previous period`}
        disabled={selectedIndex === 0}
        onClick={() => onChange(analyticsPeriods[selectedIndex - 1].value)}
      >
        <ChevronLeftIcon fontSize="small" />
      </IconButton>
      <Typography
        component="span"
        aria-live="polite"
        sx={{ fontSize: "0.8rem", minWidth: 65, textAlign: "center", whiteSpace: "nowrap" }}
      >
        {analyticsPeriods[selectedIndex].label}
      </Typography>
      <IconButton
        size="small"
        aria-label={`${label}: next period`}
        disabled={selectedIndex === analyticsPeriods.length - 1}
        onClick={() => onChange(analyticsPeriods[selectedIndex + 1].value)}
      >
        <ChevronRightIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}

AnalyticsPeriodFilter.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};
